import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { MediaAnalysisEmployerBrandingPageBg } from "@/components/site/MediaAnalysisEmployerBrandingPageBg";
import { MEDIA_ANALYSIS_EMPLOYER_BRANDING_META_DESCRIPTION_BG } from "@/content/meta/MediaAnalysisEmployerBrandingPageBg";

const TITLE = "Анализ на работодателската марка | Perceptica";

export const Route = createFileRoute("/bg/media-analysis/employer-branding")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: MEDIA_ANALYSIS_EMPLOYER_BRANDING_META_DESCRIPTION_BG },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: MEDIA_ANALYSIS_EMPLOYER_BRANDING_META_DESCRIPTION_BG },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: MEDIA_ANALYSIS_EMPLOYER_BRANDING_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/media-analysis/employer-branding" },
      ...ogImageMeta("bg", "/media-analysis/employer-branding"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/media-analysis/employer-branding", service: { name: "Анализ на работодателски бранд", description: "Анализ на работодателски бранд от Perceptica за Югоизточна Европа.", serviceType: "Анализ на работодателски бранд" } }),
  }),
  component: MediaAnalysisEmployerBrandingPageBg,
});
